// 配置API接口地址
// var root = 'http://192.168.5.84:5204/ncc.php';//杨景辉本地
// var root = 'https://api.info-rae.cn'; //线上
var root = 'https://www.globaltalent.net/ncc.php'; //线上
var key = '123456';

var axios = require('axios');
var mds = require('js-md5');
/*
  接口处理函数
*/

function signData(data) {
	delete data.sign;
	data = data ? data : {};
	data.timestamp = Math.round(new Date().getTime() / 1000).toString(); //时间戳
	var sortData = [];
	for (var k in data) {
		sortData.push(k);
	}
	sortData = sortData.sort();
	var signStr = '';
	for (var i in sortData) {
		let item = data[sortData[i]];
		if (typeof item == 'object') {
			item = JSON.stringify(item);
		}
		signStr += sortData[i] + item;
	}
	if (document.title == '中国长三角中心-登录') {
		data.sign = mds(key + signStr);
	} else {
		// if (url == '/Exports/download') {
		//     data.sign = mds(key + signStr);
		// } else {
		//     data.sign = mds(key + signStr + localStorage.getItem('token'));
		// }
		data.sign = mds(key + signStr + localStorage.getItem('token'));
	}
	return data;
}



function apiAxios(method, url, params, success, failure) {
	// let that = this;
	let headers = {};
	if (params) {
		// params = filterNull(params);
		params = params ? signData(params) : signData();
		// params = params ? signData(params, url) : signData();
	}
	if (document.title == '中国长三角中心-登录') {

	} else {
		headers = {
			token: localStorage.getItem('token')
		};
	}
	axios({
		method: method,
		url: url,
		headers: headers,
		data: method === 'POST' || method === 'GET' ? params : null,
		baseURL: root,
		withCredentials: false,
	}).then(function(res) {
		if (res.data.code !== 200) {
			if (failure) {
				failure(res.data)
			} else {
				if (res.data.code === 401) {
					// 登录状态失效
					// ELEMENT.Message.success(res.data.msg);
					window.localStorage.removeItem('token');
					window.location.href = '/';
					return;
				}
			}
		}
		if (success) {
			success(res);
		}
	}).catch(function(err) {
		if (failure) {
			failure(err);
		} else {
			console.log(err);
		}
	})
}

export default {
	get: function(url, params, success, failure) {
		return apiAxios('GET', url, params, success, failure)
	},
	post: function(url, params, success, failure) {
		return apiAxios('POST', url, params, success, failure)
	},
	put: function(url, params, success, failure) {
		return apiAxios('PUT', url, params, success, failure)
	},
	delete: function(url, params, success, failure) {
		return apiAxios('DELETE', url, params, success, failure)
	}
}